module.exports = __webpack_public_path__ + "static/media/elk_sample_map_overlay.e26fcd62.svg";